import styled from 'styled-components';
import * as typographyStyles from '../../typography';

export type TypographyVariant =
  | 'displayLarge'
  | 'displayMedium'
  | 'displaySmall'
  | 'headlineLarge'
  | 'headlineMedium'
  | 'headlineSmall'
  | 'titleLarge'
  | 'titleMedium'
  | 'titleSmall'
  | 'labelLarge'
  | 'labelMedium'
  | 'labelSmall'
  | 'bodyLarge'
  | 'bodyMedium'
  | 'bodySmall'
  | 'displayLargeEmphasized'
  | 'displayMediumEmphasized'
  | 'displaySmallEmphasized'
  | 'headlineLargeEmphasized'
  | 'headlineMediumEmphasized'
  | 'headlineSmallEmphasized'
  | 'titleLargeEmphasized'
  | 'titleMediumEmphasized'
  | 'titleSmallEmphasized'
  | 'labelLargeEmphasized'
  | 'labelMediumEmphasized'
  | 'labelSmallEmphasized'
  | 'bodyLargeEmphasized'
  | 'bodyMediumEmphasized'
  | 'bodySmallEmphasized';

export interface TypographyProps {
  variant: TypographyVariant;
  color?: string;
  align?: 'left' | 'center' | 'right' | 'justify';
}

export const Typography = styled.div<TypographyProps>`
  ${({ variant }) => typographyStyles[variant] || typographyStyles.bodyMedium}
  ${({ color }) => (color ? `color: ${color};` : '')}
  ${({ align }) => (align ? `text-align: ${align};` : '')}

  a {
    color: var(--sys-color--primary);
    text-decoration: underline;
    cursor: pointer;
  }

  &[href] {
    color: var(--sys-color--primary);
    text-decoration: underline;
    cursor: pointer;
  }
`;

export const LinkText = styled.a`
  color: var(--sys-color--primary);
  display: block;
  margin-top: 8px;
  text-decoration: none;
  cursor: pointer;

  && {
    text-decoration: none;
  }
`;

export default Typography;
